export interface IBodySubSite {
  bodySubsiteId: string,
  code: string,
  nameEnglish: string,
  nameArabic: string,
  claimTypeId: string,
  claimTypeEnglish: string,
  claimTypeArabic: string
}

export const bodysubSiteConfig = {
  entityName: 'CONFIGURATION.BODYSUBSITE.TITLE',
  code: 'FORM_FIELD.CODE',
  nameEnglish: 'FORM_FIELD.ENGLISH_NAME',
  nameArabic: 'FORM_FIELD.ARABIC_NAME',
  claimTypeId: 'CONFIGURATION.CLAIM_TYPE.TITLE'
};